// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Col, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";
import AbsenceReasonsForm from "./absence-reasons-form";
import type { AbsenceReason } from "@modules/service/reducer/absence-reasons/types";

type OwnProps = $Exact<{
  schema: ?Object,
  onSubmit: (data: AbsenceReason) => void,
  onClose: () => void,
}>;

type Props = $Exact<{ ...OwnProps, ...PropsFromLocalize }>;

export class AbsenceReasonsAddModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = (formData: Object) => {
    this.props.onSubmit(formData);
  };

  get data() {
    return {
      name: null,
      displayName: null,
      reasonType: null,
      parentReason: null,
      nurseTransferEligibility: "ALWAYS",
      isActive: null,
    };
  }

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader toggle={this.props.onClose} className="d-flex justify-content-between">
          {this.props.t("ADD_ABSENCE_REASON_MODAL_TITLE")}
        </ModalHeader>
        <ModalBody>
          {this.props.schema && (
            <AbsenceReasonsForm
              ref={this.formRef}
              data={this.data}
              schema={this.props.schema}
              onSubmit={this.handleSubmit}
            />
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onClose}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="add_circle" onClick={this.submitForm}>
            {this.props.t("ADD")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(AbsenceReasonsAddModal);
